export const TryAnother = Symbol("TryAnother");
export type TryAnother = typeof TryAnother;
